import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'cipo-notify-new-version',
  template: `
    <span matSnackBarLabel>
      <span>{{ 'newVersion.title' | translate }}</span>
      <br />
      <span (click)="dismiss()" [innerHTML]="'newVersion.releaseNotes' | translate: { url } | safeHtml"> </span>
    </span>
    <span matSnackBarActions>
      <button mat-button matSnackBarAction (click)="dismiss()">
        {{ 'actions.refresh' | translate }}
      </button>
    </span>
  `,
  styles: `
    :host {
      display: flex;
    }
  `,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction, TranslateModule, SafeHtmlPipe],
})
export class NotifyNewVersionComponent {
  private readonly snackBarRef = inject(MatSnackBarRef);

  url = environment.releaseNotesUrl;

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
